import React, { useEffect, useState } from "react";
import {
  CFormInput,
  CForm,
  CContainer,
  CRow,
  CCol,
  CFormLabel,
  CFormText,
  CBadge,
} from "@coreui/react";
import { Typography } from "@mui/material";
import "./QuizComponent.css";
import postApiCall from "src/server/postApiCall";

function FillInTheBlanksSuperadmin({
  type,
  num,
  question,
  score,
  onAnswerChange,
  questionID,
  questionTypeID,
  data,
  isCorrect,
  valueReset,
}) {
  // Get the default value from the data prop if it exists
  const defaultValue = data?.[0]?.value || "";
  const [value, setValue] = useState(type === "3" ? "" : defaultValue);

  const handleSelectAnswer = (option) => {
    onAnswerChange(questionID, questionTypeID, option);
  };

  useEffect(() => {
    if (type === "3") {
      setValue("");
    }
  }, [valueReset, type]);

  const getClassName = (ans) => {
    if (isCorrect === 1) {
      return "reviewAnswers";
    } else if (isCorrect === 0) {
      return "reviewAnswers2";
    } else {
      return "";
    }
  };

  return (
    <CContainer className="mb-3 questionContainer">
      <ol>
        <CRow className="justify-content-between">
          <CCol>
            <div className="row d-flex align-items-center">
              <Typography
                variant="question"
                component="div"
                gutterBottom
                sx={{ color: "primary.main", mb: 2 }}
              >
                {`Q${num + 1}. ${question}`}
              </Typography>
               <CCol xs="auto"></CCol>
              <CCol className="form-group" xs={2} style={{ padding: "0px" }}>
                <CFormInput
                  value={value}
                  disabled={type === "3" ? false : true}
                  className={`border-0 border-bottom rounded-0 blank ${getClassName(
                    data
                  )}`}
                  onChange={(e) => {
                    handleSelectAnswer(e.target.value);
                    setValue(e.target.value);
                  }}
                  type="text"
                />
              </CCol>
            </div>
          </CCol>

          <CCol className="align-self-start" xs={2} md={1}>
            <div className="text-center">
              <h2>
                <CBadge shape="rounded-pill" color="primary">
                  {score}
                </CBadge>
              </h2>
            </div>
          </CCol>
        </CRow>
      </ol>
    </CContainer>
  );
}

export default FillInTheBlanksSuperadmin;
